import { useBooking } from '../../../../../../contexts/ticketBookingContext/TicketBookingContext';
import FillPassengers from '../fillPassengers/FillPassengers';
import PaymentMethod from '../choosePaymentMethod/PaymentMethod';
import InvoiceTerms from '../invoiceTerms/InvoiceTerms';

function CompleteStatementBookingTabItems() {
  const {
    departurePassengersForm,
    bookingData,
    savedPassengers,
    services,
    returnPassengersForm,
  } = useBooking();

  const isReturnWay = Boolean(bookingData?.return?.rideId);

  return [
    {
      key: 1,
      children: <FillPassengers
        form={departurePassengersForm}
        rideId={bookingData?.departure?.rideId}
        savedPassengers={savedPassengers}
        services={services}
        bookingType
      />,
    },
    {
      key: isReturnWay ? 2 : 100,
      children: <FillPassengers
        form={returnPassengersForm}
        rideId={bookingData?.return?.rideId}
        savedPassengers={savedPassengers}
        services={services}
        bookingType
      />,
    },
    {
      key: isReturnWay ? 3 : 2,
      children: bookingData?.invoice ? <InvoiceTerms /> : <PaymentMethod />,
    }];
}

export default CompleteStatementBookingTabItems;
